class Storage {
  static token = null;

  static setToken(token) {
    this.token = token;
  }

  static getToken() {
    return this.token;
  }
}

module.exports = Storage;
